export var Ethnicity;
(function (Ethnicity) {
    Ethnicity["Hispanic"] = "H";
    Ethnicity["NotHispanic"] = "N";
    Ethnicity["NoAnswer"] = "X";
})(Ethnicity || (Ethnicity = {}));
//# sourceMappingURL=Ethnicity.js.map